import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';
import { openNewWindow } from '../../../../lib/common';
import { makeDetailPageUrl } from '../../../../lib/utils/urlUtils';
import { SUB_PAGE_MANAGEMENT_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { HomeItemV2, HomeListOptionV2 } from '../../../../types/home/list';
import { Columns } from '../../../../types/common/table';
import TableFilterInput from '../../../../components/table/TableFilterInput';
import { HOME_TAB_STATUS_TYPE_V2 } from '../../../../constants/service/app/homeConstantsV2';

export const eventReactTableColumns: Columns<HomeItemV2, HomeListOptionV2> = (data) => {
  const { filterOption, onFilter } = data;
  return [
    {
      accessor: 'status',
      Header: '활성',
      width: 100,
      Cell: (row) => (row.value === HOME_TAB_STATUS_TYPE_V2.ACTIVE ? '활성' : '비활성'),
    },
    {
      accessor: 'id',
      Header: '서브 페이지 ID',
      width: 100,
      filterable: !!filterOption,
      Cell: (row) => (
        <Anchor
          color="primary"
          isUnderLine
          text={row.value}
          onClick={(): void => openNewWindow(makeDetailPageUrl(SUB_PAGE_MANAGEMENT_URL_PATH, row.value))}
        />
      ),
      Filter: () => (
        <TableFilterInput
          type="number"
          option={filterOption.id}
          onFilter={(id: string): void => onFilter({ id: isNil(id) ? id : Number(id) })}
        />
      ),
    },
    {
      accessor: 'title',
      Header: '타이틀',
      filterable: !!filterOption,
      Filter: () => (
        <TableFilterInput option={filterOption.title} onFilter={(title: string): void => onFilter({ title })} />
      ),
    },
    {
      accessor: 'memo',
      Header: '메모',
      filterable: !!filterOption,
      Filter: () => (
        <TableFilterInput option={filterOption.memo} onFilter={(memo: string): void => onFilter({ memo })} />
      ),
    },
  ];
};
